module.exports = __webpack_public_path__ + "static/media/drawview.09a08d0c.md";